import { colors } from "@areahub/theme";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  Text,
  MenuList,
  Flex,
} from "@chakra-ui/react";
import { Link } from "@ui/components/link";

export interface IndustriesMenu {
  buttonLabel: string;
  industriesMenuItem: {
    option: string;
    url: string;
  }[];
  onToggle(): void;
}

export const IndustriesDropdownMenu = (props: IndustriesMenu) => {
  return (
    <>
      <Box
        display={{
          base: "none",
          lg: "block",
        }}
      >
        <Menu>
          <MenuButton color={"white"} fontWeight={"semibold"}>
            {props.buttonLabel}
          </MenuButton>
          <MenuList w={"65%"} bg={colors.enterpriseColors.blue["500"]}>
            {props?.industriesMenuItem.map((item, idx) => (
              <MenuItem
                key={`industries-menu-desktop-option-${idx}`}
                fontWeight={"semibold"}
                bg={colors.enterpriseColors.blue["500"]}
              >
                <Link
                  href={item.url}
                  display="inline-block"
                  color={colors.enterpriseColors.blue["50"]}
                  borderBottom="3px solid transparent"
                  _hover={{
                    borderBottom: `3px solid ${colors.enterpriseColors.blue["100"]}`,
                    textDecor: "none",
                  }}
                >
                  {item.option}
                </Link>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
      <Box
        display={{
          lg: "none",
        }}
      >
        <Accordion allowToggle w={"250px"}>
          <AccordionItem border={0}>
            <AccordionButton p={0}>
              <Box as="span" flex="1" textAlign="left">
                {props.buttonLabel}
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4} display={"flex"} flexDir={"column"} gap={3}>
              {props?.industriesMenuItem.map((item, idx) => (
                <Link
                  key={`industry-dropdown-mobile-option-${idx}`}
                  color={"white"}
                  href={item.url}
                  py={1}
                  onClick={props.onToggle}
                >
                  {item.option}
                </Link>
              ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};

export interface SolutionsDropdownMenu {
  menus: Omit<IndustriesMenu, "onToggle">[];
  label: string;
  onToggle?: () => void;
}

export const SolutionsDropdownMenu = ({
  menus,
  label,
  onToggle,
}: SolutionsDropdownMenu) => {
  return (
    <>
      <Box
        display={{
          base: "none",
          lg: "block",
        }}
      >
        <Menu>
          <MenuButton color={"white"} fontWeight={"semibold"}>
            {label}
          </MenuButton>
          <MenuList w={"65%"} bg={colors.enterpriseColors.blue["500"]} p={5}>
            {menus.map((menu, idx) => (
              <Box
                key={`solutions-menu-desktop-${idx}`}
                pt={idx !== 0 ? 10 : 0}
              >
                <Text color={"white"}>{menu.buttonLabel}</Text>
                {menu?.industriesMenuItem.map((item, idx) => (
                  <MenuItem
                    key={`solutions-menu-desktop-option-${idx}`}
                    fontWeight={"semibold"}
                    bg={colors.enterpriseColors.blue["500"]}
                  >
                    <Link
                      href={item.url}
                      display="inline-block"
                      color={colors.enterpriseColors.blue["50"]}
                      borderBottom="3px solid transparent"
                      _hover={{
                        borderBottom: `3px solid ${colors.enterpriseColors.blue["100"]}`,
                        textDecor: "none",
                      }}
                    >
                      {item.option}
                    </Link>
                  </MenuItem>
                ))}
              </Box>
            ))}
          </MenuList>
        </Menu>
      </Box>

      <Box
        display={{
          lg: "none",
        }}
      >
        <Accordion allowToggle w={"250px"}>
          <AccordionItem border={0}>
            <AccordionButton p={0}>
              <Box as="span" flex="1" textAlign="left">
                {label}
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4} display={"flex"} flexDir={"column"}>
              {menus.map((menu, idx) => (
                <Box
                  key={`solutions-menu-mobile-${idx}`}
                  mt={idx !== 0 ? 8 : 0}
                >
                  <Text fontWeight={"semibold"} pb={3}>
                    {menu.buttonLabel}
                  </Text>
                  <Flex flexDir={"column"} pl={3} gap={3}>
                    {menu?.industriesMenuItem.map((item, idx) => (
                      <Link
                        key={`solutions-menu-mobile-option-${idx}`}
                        color={"white"}
                        href={item.url}
                        py={1}
                        onClick={onToggle}
                      >
                        {item.option}
                      </Link>
                    ))}
                  </Flex>
                </Box>
              ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};
